import { type AccessTokenType, FeatureFlags } from "@finway-group/shared/lib/models"
import jwt from "jsonwebtoken"
import moment, { type unitOfTime } from "moment"
import { ErrorTypes } from "~Shared/error.types"

export const decodeAndFormatAccessTokenValidTime = (encodedAccessToken: string | null, unit: unitOfTime.Diff = "seconds") => {
    if (!encodedAccessToken) {
        throw new Error(ErrorTypes.ACCESS_TOKEN_MISSING)
    }

    const accessToken = decodeAccessToken(encodedAccessToken)
    const time = moment(Number(accessToken.exp) * 1000)
    const dif = time.diff(moment(), unit)
    return dif
}

export const decodeAndFormatAccessToken = (encodedAccessToken: string | null) => {
    if (!encodedAccessToken) {
        throw new Error(ErrorTypes.ACCESS_TOKEN_MISSING)
    }

    const decodedAccessToken = decodeAccessToken(encodedAccessToken)
    const featureFlags = decodedAccessToken?.featureFlags ? new FeatureFlags(decodedAccessToken.featureFlags) : undefined
    const companyId = decodedAccessToken?.currentCompanyId as string

    return {
        userId: decodedAccessToken?.id,
        accessToken: decodedAccessToken,
        companyId,
        featureFlags,
        isSsoLogin: decodedAccessToken?.isSsoLogin === true,
    }
}

export const decodeAccessToken = (encodedToken: string) => {
    const decodedAccessToken = jwt.decode(encodedToken) as AccessTokenType
    return decodedAccessToken
}

export const getCompanyProfile = (accessToken: AccessTokenType, companyId: string | undefined): AccessTokenType["companyProfiles"][number] | undefined => {
    if (!companyId) {
        return undefined
    }

    return accessToken.companyProfiles.find((profile) => profile.companyId === companyId)
}
